import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from '../../shared/services/utils/toastr.service';
import { AppAuthService } from './app-auth.service';
import { CurrentMemberProvider } from './current-member-provider.service';

@Injectable({
  providedIn: 'root',
})
export class InternalMemberGuard implements CanActivate {
  constructor(
    protected router: Router,
    private toastrService: ToastrService,
    private currentMemberProvider: CurrentMemberProvider,
  ) {
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const isAuthenticated = this.currentMemberProvider.isAuthenticated();
    if (false === isAuthenticated) {
      return false;
    }

    if (this.currentMemberProvider.isExternal()) {
      this.router.navigateByUrl(AppAuthService.defaultPage);
      this.toastrService.error('INTERNALMEMBERGUARD.ACCESSDENIED');

      return false;
    }

    return this.currentMemberProvider.isInternal();
  }
}
